import Chip from '@material-ui/core/Chip';
import Grid from '@material-ui/core/Grid';
import dxLogo from 'assets/dx_white.png';
import TotalLogo from 'components/TotalLogo';
import { PATHS } from 'constants/paths';
import { getUnifiedWellName } from 'helpers/WellHelper';
import { Link } from 'react-router-dom';
import { useSelectCurrentWell } from 'redux/Wells/selectors';

import styles from './HeaderMobile.module.scss';

type Props = {
  withMobileWellSelect?: boolean;
};

const HeaderMobile = ({ withMobileWellSelect = true }: Props) => {
  const well = useSelectCurrentWell();

  return (
    <Grid container component="header" className={styles.headerContainer}>
      <Link to={PATHS.HOME} className={styles.logoLink}>
        <TotalLogo className={styles.totalLogo} />
        <img className={styles.drillxLogo} alt="DrillX logo" src={dxLogo} />
      </Link>
      {withMobileWellSelect && <Chip label={well ? getUnifiedWellName(well) : ''} />}
    </Grid>
  );
};

export default HeaderMobile;
